import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=45a74bce&"
import script from "./CartDetail.vue?vue&type=script&lang=js&"
export * from "./CartDetail.vue?vue&type=script&lang=js&"
import style0 from "./CartDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports